import type {
	ConfluenceLength,
	ConfluenceTone,
} from '../../common/hooks/__generated__/useUpdateAudioPreferencesMutation.graphql';

import type { AudioFeatureType } from './models/AudioFeature';

export type CustomTone = ConfluenceTone;
export type CustomLength = ConfluenceLength;

export enum AudioFormat {
	PCM = 'pcm',
	MP3 = 'mp3',
	JSON = 'json',
}

export interface AudioRequest {
	mainResourceARI: string;
	supportingResourceARIs?: string[];
	locale: string;
	type: AudioFeatureType;
	instructions: {
		tone: CustomTone;
		length: CustomLength;
	};
	format: AudioFormat;
	activationId: string;
	/** Optional AbortSignal to cancel the fetch request */
	signal?: AbortSignal;
}

export const getAudio = async ({
	mainResourceARI,
	supportingResourceARIs = [],
	locale,
	type,
	instructions,
	format,
	activationId,
	signal,
}: AudioRequest) => {
	const resourceARIs = [mainResourceARI, ...supportingResourceARIs];
	const resources = resourceARIs.map((resourceAri) => ({ resource_ari: resourceAri }));

	const response = await fetch('/gateway/api/v2/audio', {
		method: 'POST',
		body: JSON.stringify({
			resources,
			locale,
			type,
			user_instruction: instructions,
			format,
		}),
		headers: {
			'Content-Type': 'application/json',
			'ATL-ActivationId': activationId,
		},
		signal,
	});

	if (!response.ok) {
		const errorBody = await response.text();
		throw new Error(`Audio request failed with status ${response.status}: ${errorBody}`);
	}

	if (!response.body) {
		throw new Error('Response body is null');
	}

	return response.body;
};
